// Normalize a Lao mobile number to the WhatsApp wire format: 856 + 20|30 + last 8 digits.
// Accepts anything the user might type — '020 5555 1234', '+85620...', '2055551234'.
// Returns '' for empty input. The backend's cleanPhone() only handles the '020…'
// case, so this client-side normaliser is load-bearing for 30-prefix numbers.
export function normalizeLaoPhone(phone) {
    if (!phone) return '';
    const digits = String(phone).replace(/\D/g, '');
    let prefix = '20'; // default
    if (digits.startsWith('85630') || digits.startsWith('030') || (digits.startsWith('30') && digits.length <= 10)) {
        prefix = '30';
    } else if (digits.startsWith('85620') || digits.startsWith('020') || (digits.startsWith('20') && digits.length <= 10)) {
        prefix = '20';
    }
    const last8 = digits.slice(-8);
    return `856${prefix}${last8}`;
}

// The shape the QR-payment endpoints validate against.
export const LAO_WHATSAPP_REGEX = /^8562[03]\d{8}$/;

export function isValidLaoWhatsApp(phone) {
    return LAO_WHATSAPP_REGEX.test(String(phone || ''));
}

export default normalizeLaoPhone;
